import {
  Alert,
  Dialog,
  Stack,
  TextField,
} from '@all-manager/design-system-v2';
import { Controller } from 'react-hook-form';
import type { SpaceMemberWithProfile } from '../../types';
import RoleField from '../RoleField/RoleField';
import useEditMemberModal from './useEditMemberModal';

type Props = {
  spaceId: string;
  member: SpaceMemberWithProfile;
  onClose: () => void;
};

export default function EditMemberModal(props: Props) {
  const hook = useEditMemberModal({
    spaceId: props.spaceId,
    member: props.member,
    onClose: props.onClose,
  });

  return (
    <Dialog
      open
      onClose={props.onClose}
      onSubmit={hook.onSubmit}
      maxWidth="sm"
      fullWidth
      title="Modifier le membre"
      closeLabel="Fermer"
      actions={{
        primaryAction: {
          label: 'Enregistrer',
          type: 'submit',
          loading: hook.isSubmitting,
        },
        secondaryAction: {
          label: 'Annuler',
          onClick: props.onClose,
          disabled: hook.isSubmitting,
        },
      }}
    >
      <Stack spacing={2}>
        {hook.serverError ? <Alert severity="error">{hook.serverError}</Alert> : null}

        <Controller
          name="firstName"
          control={hook.form.control}
          render={({ field, fieldState }) => (
            <TextField
              name={field.name}
              inputRef={field.ref}
              onBlur={field.onBlur}
              onChange={field.onChange}
              value={field.value}
              label="Prénom"
              autoFocus
              required
              fullWidth
              error={!!fieldState.error}
              helperText={fieldState.error?.message}
            />
          )}
        />
        <Controller
          name="lastName"
          control={hook.form.control}
          render={({ field, fieldState }) => (
            <TextField
              name={field.name}
              inputRef={field.ref}
              onBlur={field.onBlur}
              onChange={field.onChange}
              value={field.value}
              label="Nom"
              required
              fullWidth
              error={!!fieldState.error}
              helperText={fieldState.error?.message}
            />
          )}
        />

        <Controller
          name="role"
          control={hook.form.control}
          render={({ field }) => (
            <RoleField
              name={field.name}
              value={field.value}
              onChange={field.onChange}
              onBlur={field.onBlur}
            />
          )}
        />
      </Stack>
    </Dialog>
  );
}
